module.exports = __webpack_public_path__ + "static/img/2.0112b885.gif";